import { createAction } from 'redux-actions';
import * as Actions from '../constants/actions';
import { StudentData } from '../models/Student';

export const login = createAction<StudentData>(Actions.STUDENT_LOGIN);
export const authenticate = createAction<StudentData>(Actions.STUDENT_AUTHENTICATE);


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/actions/student.ts